import keyMirror from 'keymirror';

export default keyMirror({
  SET_CURRENT_MENU: null,
  SET_MODAL_CONFIG: null,
  SET_LOADING_FLAG: null,
  SET_DISABLE_HEADER_FLAG: null,
  SET_SIDEBAR_FLAG: null,
  SET_TO_BE_SELECTED_NAV: null,
  HIDE_HEADER_FLAG: null,
  MANAGE_CREDENTIALS_FLAG: null,
});
